module.exports = __webpack_public_path__ + "img/top-2-4.81a661e5.jpg";